export const A2_COLOR = '#FFFF00';
export const NON_COLOR = '#52525C';
export const A2_ALPHA = (a: number) => `rgba(255,255,0,${a})`;
export const NON_ALPHA = (a: number) => `rgba(82,82,92,${a})`;

export const barColor = (d: { a2: boolean }, alpha: number) =>
  d.a2 ? A2_ALPHA(alpha) : NON_ALPHA(alpha);
export const solidColor = (d: { a2: boolean }) => (d.a2 ? A2_COLOR : NON_COLOR);
export const lblColor = (d: { a2: boolean }) =>
  d.a2 ? A2_COLOR : 'rgba(180,180,180,0.9)';

export const TOOLTIP_STYLE = {
  backgroundColor: 'rgba(20,20,22,0.95)',
  borderColor: 'rgba(255,255,255,0.15)',
  borderWidth: 1,
  padding: 10,
  titleFont: { family: 'Arial', size: 12 },
  bodyFont: { family: 'Arial', size: 11 },
} as const;
